import { graphql } from "gql";

const REMOVE_FROM_MESSAGE_THREAD_MUTATION = graphql(`
  mutation RemoveFromMessageThread(
    $messageThreadId: ID!
    $dryRunInput: RemoveFromMessageThreadDryRunInput!
    $input: RemoveFromMessageThreadInput!
  ) {
    removeFromMessageThread(
      messageThreadId: $messageThreadId
      dryRunInput: $dryRunInput
      input: $input
    ) {
      ...MessageThread
    }
  }
`);

export default REMOVE_FROM_MESSAGE_THREAD_MUTATION;
